import * as React from "react";

export const FinanceIcon = ({ ...props }) => {
  return (
    <svg width={31} height={31} viewBox="0 0 31 31" fill="none" {...props}>
      <rect width={31} height={31} rx={8} fill="#fff" />
      <rect
        x={0.5}
        y={0.5}
        width={30}
        height={30}
        rx={7.5}
        stroke="#4C5CFB"
        strokeOpacity={0.1}
      />
      <path
        d="M15.5 9v12.833M18.417 11.333h-4.375a2.042 2.042 0 000 4.084h2.916a2.042 2.042 0 110 4.083H12"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
